import React, { useState } from 'react';
import Header from '../../../components/Header';
import TemporaryOperatingInstructionTable from './TemporaryOperatingInstructions';
import TemporaryInstructionHeader from './TemporaryInstructionHeader';
import { Plus, X, AlertCircle } from 'lucide-react';
import TemporaryOperatingInstructionModal from './TemporaryOperatingInstructionModal.tsx';
import SuccessModal from '../../../components/ConfirmModal/SuccessModal';
import { useSelector } from 'react-redux';

const TemporaryOperatingInstruction = () => {
  /**  USER ROLE */
  const role = useSelector((state: any) => state.user.role);
  const isShiftSupervisor = role === 'shift_supervisor';

  const [tempModal, setTempModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const [searchQuery, setSearchQuery] = useState('');

  const handleSearch = (query: string) => {
    setSearchQuery(query);
  };

  return (
    <div className="flex-1 flex flex-col overflow-hidden">
      <Header title={'Temporary Operating Instruction'} />
      <div className="flex-1 overflow-auto p-6">
        <div className="flex items-center mb-6">
          {isShiftSupervisor && (
            <button
              className="flex items-center gap-2 bg-[#e84545] text-white px-4 py-2 rounded-md text-sm font-medium hover:opacity-90"
              onClick={() => setTempModal(true)}
            >
              <Plus size={16} /> Temporary Operating Instruction
            </button>
          )}

          <div className="ml-auto">
            <TemporaryInstructionHeader onSearch={handleSearch} />
          </div>
        </div>

        {/* Error Toast */}
        {errorMessage && (
          <div className="fixed bottom-6 right-6 z-[100] animate-slide-up">
            <div className="bg-red-500 text-white px-6 py-4 rounded-lg shadow-lg flex items-start gap-3 min-w-[320px] max-w-md">
              <AlertCircle size={20} className="flex-shrink-0 mt-0.5" />
              <div className="flex-1">
                <h3 className="font-semibold mb-1">Error</h3>
                <p className="text-sm">{errorMessage}</p>
              </div>
              <button onClick={() => setErrorMessage(null)} className="flex-shrink-0 hover:bg-red-600 rounded p-1 transition-colors">
                <X size={16} />
              </button>
            </div>
          </div>
        )}

        <TemporaryOperatingInstructionTable
          key={refreshTrigger}
          searchQuery={searchQuery}
          onError={(message) => {
            setErrorMessage(message);
            setTimeout(() => setErrorMessage(null), 5000);
          }}
        />
      </div>

      {tempModal && (
        <TemporaryOperatingInstructionModal
          onClose={() => {
            setTempModal(false);
          }}
          onSuccess={() => {
            setTempModal(false);
            setRefreshTrigger((prev) => prev + 1);
            setShowSuccessModal(true);
          }}
          onError={(message) => {
            setErrorMessage(message);
            setTimeout(() => setErrorMessage(null), 5000);
          }}
        />
      )}

      {/*  SUCCESS MODAL */}
      <SuccessModal
        isOpen={showSuccessModal}
        title="Temporary Operating Instruction Created"
        message="Temporary Operating Instruction added successfully."
        buttonText="OK"
        onButtonClick={() => setShowSuccessModal(false)}
        onClose={() => setShowSuccessModal(false)}
      />
    </div>
  );
};

export default TemporaryOperatingInstruction;
